export default "/kiban/_next/static/images/yellow-4185a4882dc6ca5a25fc641a0cd3df3a.png";